import React from "react";
import PaymentHistory from "../payment-history/payment-history";
import locale from "localization";

const PaymentHistoryForConsumer = () => {
  const paymentHistoryColumns = [
    { key: "redemptionId", text: locale.redemptionId, style: { minWidth: "8%" } },
    { key: "redeemedAt", text: locale.redemptionDate, style: { minWidth: "10%" } },
    {
      key: "nameAndMobileNumber",
      text: (
        <>
          {locale.name} / <br /> {locale.mobileNumber}
        </>
      ),
      style: { minWidth: "10%" },
    },
    {
      key: "productVolume",
      text: (
        <>
          {locale.product} / <br /> {locale.volume}
        </>
      ),
      style: { minWidth: "8%" },
    },
    {
      key: "totalCreditAmountSales",
      text: (
        <>
          {locale.totalCreditAmount} / <br /> {locale.totalSales}
        </>
      ),
      style: { minWidth: "10%" },
    },
    { key: "averageCreditPrice", text: locale.averageCreditPrice, style: { minWidth: "6%" } },
    {
      key: "discountPremium",
      text: (
        <>
          {locale.discount} / <br /> {locale.premium}
        </>
      ),
      style: { minWidth: "8%" },
    },
    { key: "status", text: locale.status, style: { minWidth: "8%" } },
    { key: "remarks", text: locale.remarks, style: { minWidth: "6%" } },
    {
      key: "settlementStatus",
      text: `${locale.settlementStatus}/${locale.settlementId}`,
      style: { minWidth: "10%" },
    },
    { key: "options", text: locale.actions, style: { minWidth: "5%" } },
  ];

  return <PaymentHistory title={locale.plcPayWithLiters} columns={paymentHistoryColumns} />;
};

export default PaymentHistoryForConsumer;
